import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useExposureByEnvironment } from '@/hooks/discovery/exposure';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useEnvironmentScope } from '../useEnvironmentScope';

export const useExposure = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;
  const { userId } = useEnvironmentScope();

  const [{ fetching, error, data }] = useExposureByEnvironment({
    environmentId: validEnvironmentId,
    userId,
    uniqueId: uniqueId?.raw ?? '',
    pause: uniqueId?.resourceType !== 'exposure',
  });

  const exposureQuery = useMemo(() => {
    const appliedEdge = data?.environment.applied?.exposures.edges?.[0];
    return {
      fetching,
      error,
      data: { applied: appliedEdge?.node, definition: null },
    };
  }, [fetching, error, data]);

  return exposureQuery;
};
